import { render, staticRenderFns } from "./score-card.vue?vue&type=template&id=30062381"
import script from "./score-card.vue?vue&type=script&lang=js"
export * from "./score-card.vue?vue&type=script&lang=js"
import style0 from "./score-card.vue?vue&type=style&index=0&id=30062381&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports